module.exports = __webpack_public_path__ + "img/logo_tqt.c81d4956.webp";